/**
 * Ulefone Mega Nav
 * Desktop: hover panels + series switch
 * Mobile: DJI-style full-screen drill-down
 */
(() => {
  const DESKTOP_MQ = window.matchMedia('(min-width: 1150px)');

  /* ---------------- Desktop ---------------- */
  const root = document.querySelector('[data-ulefone-mega-nav]');
  if (root) {
    const OPEN_DELAY = 100;
    const CLOSE_DELAY = 180;
    const SERIES_DELAY = 60;

    let openTimer = null;
    let closeTimer = null;
    let seriesTimer = null;
    let activeItem = null;

    const mask = root.querySelector('[data-umn-mask]');

    const clearTimers = () => {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      window.clearTimeout(seriesTimer);
    };

    const closeAll = () => {
      clearTimers();
      root.querySelectorAll('.umn__top-item.is-open').forEach((item) => {
        item.classList.remove('is-open');
        const trigger = item.querySelector('[data-umn-trigger]');
        const panel = item.querySelector('[data-umn-panel]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      });
      if (mask) mask.hidden = true;
      activeItem = null;
    };

    const openItem = (item) => {
      if (!item || !DESKTOP_MQ.matches) return;
      if (activeItem === item) {
        clearTimers();
        return;
      }
      closeAll();
      const trigger = item.querySelector('[data-umn-trigger]');
      const panel = item.querySelector('[data-umn-panel]');
      if (!panel) return;
      item.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      if (mask) {
        mask.hidden = panel.hasAttribute('data-umn-dropdown');
      }
      activeItem = item;
    };

    const activateSeries = (btn) => {
      const panel = btn.closest('[data-umn-panel]');
      if (!panel) return;
      const targetId = btn.getAttribute('data-series-target');
      panel.querySelectorAll('[data-umn-series]').forEach((b) => {
        const on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panel.querySelectorAll('[data-umn-series-pane]').forEach((pane) => {
        const on = pane.id === targetId;
        pane.classList.toggle('is-active', on);
        pane.hidden = !on;
      });
    };

    root.querySelectorAll('.umn__top-item').forEach((item) => {
      const trigger = item.querySelector('[data-umn-trigger]');
      const panel = item.querySelector('[data-umn-panel]');
      if (!trigger || !panel) return;

      const scheduleOpen = () => {
        if (!DESKTOP_MQ.matches) return;
        clearTimers();
        openTimer = window.setTimeout(() => openItem(item), OPEN_DELAY);
      };

      const scheduleClose = () => {
        if (!DESKTOP_MQ.matches) return;
        clearTimers();
        closeTimer = window.setTimeout(() => {
          if (activeItem === item) closeAll();
        }, CLOSE_DELAY);
      };

      item.addEventListener('mouseenter', scheduleOpen);
      item.addEventListener('mouseleave', scheduleClose);
      panel.addEventListener('mouseenter', clearTimers);
      panel.addEventListener('mouseleave', scheduleClose);

      trigger.addEventListener('click', (event) => {
        if (!DESKTOP_MQ.matches) return;
        const url = trigger.getAttribute('data-url');
        if (item.classList.contains('is-open') && url && url !== '#') {
          return;
        }
        event.preventDefault();
        openItem(item);
      });
    });

    root.querySelectorAll('[data-umn-series]').forEach((btn) => {
      btn.addEventListener('mouseenter', () => {
        if (!DESKTOP_MQ.matches) return;
        window.clearTimeout(seriesTimer);
        seriesTimer = window.setTimeout(() => activateSeries(btn), SERIES_DELAY);
      });
      btn.addEventListener('focus', () => {
        if (!DESKTOP_MQ.matches) return;
        activateSeries(btn);
      });
      btn.addEventListener('click', (event) => {
        if (!DESKTOP_MQ.matches) return;
        event.preventDefault();
        activateSeries(btn);
      });
    });

    root.querySelectorAll('[data-umn-close]').forEach((btn) => {
      btn.addEventListener('click', closeAll);
    });

    if (mask) mask.addEventListener('click', closeAll);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });

    DESKTOP_MQ.addEventListener('change', (event) => {
      if (!event.matches) closeAll();
    });
  }

  /* ---------------- Mobile ---------------- */
  const mobile = document.querySelector('[data-umn-mobile]');
  if (!mobile) return;

  // Avoid header transform creating a containing block for position:fixed
  if (mobile.parentElement !== document.body) {
    document.body.appendChild(mobile);
  }

  const collapseAll = (selector, btnAttr) => {
    mobile.querySelectorAll(selector).forEach((btn) => {
      const targetId = btn.getAttribute(btnAttr);
      const body = targetId ? mobile.querySelector(`#${CSS.escape(targetId)}`) : null;
      btn.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      if (body) {
        body.classList.add('is-collapsed');
        body.hidden = true;
      }
    });
  };

  const toggleAccordion = (btn, btnAttr, scope, exclusive) => {
    const targetId = btn.getAttribute(btnAttr);
    if (!targetId) return;

    const body = mobile.querySelector(`#${CSS.escape(targetId)}`);
    if (!body) return;

    const willOpen = body.classList.contains('is-collapsed');

    if (exclusive && willOpen) {
      scope.querySelectorAll(`[${btnAttr}]`).forEach((otherBtn) => {
        if (otherBtn === btn) return;
        const otherId = otherBtn.getAttribute(btnAttr);
        const otherBody = otherId ? mobile.querySelector(`#${CSS.escape(otherId)}`) : null;
        otherBtn.classList.remove('is-open');
        otherBtn.setAttribute('aria-expanded', 'false');
        if (otherBody) {
          otherBody.classList.add('is-collapsed');
          otherBody.hidden = true;
        }
      });
    }

    body.classList.toggle('is-collapsed', !willOpen);
    body.hidden = !willOpen;
    btn.classList.toggle('is-open', willOpen);
    btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  };

  const resetAccordions = () => {
    collapseAll('[data-umn-m-cat-toggle]', 'data-umn-m-cat-toggle');
    collapseAll('[data-umn-m-inline-toggle]', 'data-umn-m-inline-toggle');
    const scroll = mobile.querySelector('.umn-m__scroll');
    if (scroll) scroll.scrollTop = 0;
  };

  const setOpen = (open) => {
    if (open) {
      mobile.hidden = false;
      mobile.removeAttribute('hidden');
      mobile.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    } else {
      mobile.hidden = true;
      mobile.setAttribute('hidden', '');
      mobile.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    document.documentElement.classList.toggle('umn-m-lock', open);
  };

  const openMobile = () => {
    resetAccordions();
    setOpen(true);
  };

  const closeMobile = () => {
    setOpen(false);
    resetAccordions();
  };

  document.querySelectorAll('[data-umn-m-toggle]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      if (DESKTOP_MQ.matches) return;
      event.preventDefault();
      event.stopPropagation();
      if (mobile.classList.contains('is-open')) {
        closeMobile();
      } else {
        openMobile();
      }
    });
  });

  mobile.querySelectorAll('[data-umn-m-close]').forEach((btn) => {
    btn.addEventListener('click', closeMobile);
  });

  mobile.querySelectorAll('[data-umn-m-cat-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const list = mobile.querySelector('.umn-m__list');
      if (list) toggleAccordion(btn, 'data-umn-m-cat-toggle', list, true);
    });
  });

  mobile.querySelectorAll('[data-umn-m-inline-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const catBody = btn.closest('.umn-m__cat-body');
      if (catBody) toggleAccordion(btn, 'data-umn-m-inline-toggle', catBody, true);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobile.classList.contains('is-open')) {
      closeMobile();
    }
  });

  DESKTOP_MQ.addEventListener('change', (event) => {
    if (event.matches) closeMobile();
  });
})();
